import { render } from "./QueueDetailTableOutboundOverview.vue?vue&type=template&id=6c6a55fe"
import script from "./QueueDetailTableOutboundOverview.vue?vue&type=script&lang=js"
export * from "./QueueDetailTableOutboundOverview.vue?vue&type=script&lang=js"

import "./QueueDetailTableOutboundOverview.vue?vue&type=style&index=0&id=6c6a55fe&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__